import {
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_TABLE_ACTION_ERROR,
  ALL_INCIDENTS_TABLE_ACTION_FAILURE,
  ALL_INCIDENTS_TABLE_ACTION_REQUEST,
  ALL_INCIDENTS_TABLE_ACTION_SUCCESS,
} from '../../../../actions/actionTypes';

const defaultState = new Set();

const tableActionsBookmarkStatus = (state = defaultState, action) => {
  const isBookmark = action?.payload?.isBookmark;
  const incidentId = action?.payload?.incidentId;

  switch (action.type) {
    case ALL_INCIDENTS_CLEAR:
      return defaultState;

    case ALL_INCIDENTS_TABLE_ACTION_REQUEST: {
      if (isBookmark) {
        return state.add(incidentId);
      }
      return state;
    }

    case ALL_INCIDENTS_TABLE_ACTION_SUCCESS:
    case ALL_INCIDENTS_TABLE_ACTION_ERROR:
    case ALL_INCIDENTS_TABLE_ACTION_FAILURE: {
      if (isBookmark) {
        let newState = new Set(state);
        newState.delete(incidentId);
        return newState;
      }
      return state;
    }

    default:
      return state;
  }
};

export default tableActionsBookmarkStatus;
